import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";

import PlayerManager from "../../../service/player-manager";
import SocketService from "../../../service/socket";
import { PlayerStateContext, UIStateContext } from "../../../provider";

import ExpandedMode from "./expanded";
import MiniModeView from "./mini-mode";
import FullScreenMode from "./full-screen";
import View from "./view";
import { MINI_WINDOW } from "../../../constants";

const PLAYER_MODE = {
  COLLAPSED: 0,
  EXPANDED: 1,
  MINI: 2,
  FULL: 3,
};

// TODO : close full screen on resize to mini window
export default () => {
  const [UIState] = useContext(UIStateContext);
  const [playerState] = useContext(PlayerStateContext);
  const { isPlaying } = playerState;
  const { playerMode } = UIState;

  const handlePlayPause = () => {
    if (isPlaying) {
      PlayerManager.pause();
      SocketService.pause();
    } else {
      PlayerManager.resume();
      SocketService.resume();
    }
  };

  const handlePrev = () => {
    SocketService.prev();
    PlayerManager.playPrev();
  };

  const handleNext = () => {
    SocketService.next();
    PlayerManager.playNext();
  };
  useEffect(() => {}, []);

  switch (playerMode) {
    case PLAYER_MODE.MINI:
      return (
        <MiniModeView
          handlePlayPause={handlePlayPause}
          handleNext={handleNext}
          handlePrev={handlePrev}
        />
      );
    case PLAYER_MODE.FULL:
      return (
        <FullScreenMode
          handlePlayPause={handlePlayPause}
          handleNext={handleNext}
          handlePrev={handlePrev}
        />
      );
      break;
    default:
      return (
        <ExpandedMode
          handlePlayPause={handlePlayPause}
          handleNext={handleNext}
          handlePrev={handlePrev}
        />
      );
  }
};
